import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { Aide } from './models/aide.model';

@Injectable({
  providedIn: 'root',
})
export class AideService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/aides`;

  findAll = () => this.#http.get<Response<Aide>>(this.BASE_URL);

  chercheParUrlFront = (urlFront: string) => this.#http.get<Response<Aide>>(this.BASE_URL, { params: { urlFront } });
}
